import { render } from "./ThreeAxleTractorSingleAxleSemitrailer.vue?vue&type=template&id=a683f658&scoped=true&ts=true"
import script from "./ThreeAxleTractorSingleAxleSemitrailer.vue?vue&type=script&lang=ts"
export * from "./ThreeAxleTractorSingleAxleSemitrailer.vue?vue&type=script&lang=ts"

import "./ThreeAxleTractorSingleAxleSemitrailer.vue?vue&type=style&index=0&id=a683f658&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a683f658"]])

export default __exports__